export const MESSAGES_TYPES = {
    QUESTION: 'question',
    COMMENT: 'comment',
};
